import { breakpoints } from 'Components/ThemeProvider';

import * as Viewport from 'constants/responsive';

import useMedia from 'utils/useMedia';

export default function useResponsiveVariant() {
  const isDesktop = useMedia(`(min-width: ${breakpoints.md}px)`);
  const isTablet = useMedia(`(min-width: ${breakpoints.sm}px)`);

  let responsiveVariant = Viewport.MOBILE;
  if (isTablet) {
    responsiveVariant = Viewport.TABLET;
  }
  if (isDesktop) {
    responsiveVariant = Viewport.DESKTOP;
  }

  return {
    isMobile: responsiveVariant === Viewport.MOBILE,
    isTablet: responsiveVariant === Viewport.TABLET,
    isDesktop: responsiveVariant === Viewport.DESKTOP,
    responsiveVariant,
  };
}
